import { makeStyles } from '@mui/styles';
import { theme } from '~/theme/default';
export const useStyles = makeStyles(() => ({
    chipContainer: {
        borderRadius: '48px',
        padding: '9px 16px',
        backgroundColor: theme.palette.grey['200'],
    },
}));
